import { axiosInstance } from 'src/config/axiosInstance';

class CarRentalsService {
  static async fetchCarRentalOffers(searchCriteria, maxRetries, retryDelay) {
    let retries = 0;
    while (retries < maxRetries) {
      try {
        const response = await axiosInstance.post(`/offers`, searchCriteria, {
          headers: {
            'Content-Type': 'application/json',
          },
        });

        return response.data; // Assuming the flights data is in the response's data property
      } catch (error) {
        console.error('Error creating flight:', error);
        retries++;
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      }
    }
    return [];
  }

  static async deleteCarRentalById(flightId) {
    try {
      const response = await axiosInstance.post(`/flights/delete/${flightId}`);
      return response;
    } catch (error) {
      console.error('An error occurred:', error);
    }
  }

  static async fetchCarRentalDetails(flightId, maxRetries, retryDelay) {
    let retries = 0;
    while (retries < maxRetries) {
      try {
        const response = await axiosInstance.get(`/flights/${flightId}`);
        return response;
      } catch (error) {
        console.error('Error fetching flight details:', error);
        retries++;
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      }
    }
  }

  static async fetchCarRentalDetailsForProject(projectId, maxRetries, retryDelay) {
    let retries = 0;
    while (retries < maxRetries) {
      try {
        const response = await axiosInstance.get(`/flights/project/${projectId}`);
        return response;
      } catch (error) {
        console.error('Error fetching flight details:', error);
        retries++;
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      }
    }
  }

  static async createCarRental(data, maxRetries, retryDelay) {
    let retries = 0;
    while (retries < maxRetries) {
      try {
        const response = await axiosInstance.post(`/flights/new`, data, {
          headers: {
            'Content-Type': 'application/json',
          },
        });

        return response.data; // Assuming the project data is in the response's data property
      } catch (error) {
        console.error('Error creating flight:', error);
        retries++;
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      }
    }
  }
}

export default CarRentalsService;
